

const Data = [
    {
        id:0,
        name:"coupn1",
        code:"35h2q",
        product:"Abayas",
        productPrice:250,
        startDate:" 9-may-21",
        endDate:" 25-may-21"
    },
    {
        id:1,
        name:"coupn1",
        code:"ap35h2q",
        product:"Abayas",
        productPrice:250,
        startDate:" 9-may-21",
        endDate:" 25-may-21"
    },
    {
        id:2,
        name:"coupn1",
        code:"l035h2",
        product:"Abayas",
        productPrice:250,
        startDate:" 9-may-21",
        endDate:" 25-may-21"
    },
    {
        id:3,
        name:"coupn1",
        code:"y735h2",
        product:"Abayas",
        productPrice:250,
        startDate:" 9-may-21",
        endDate:" 25-may-21"
    },
    {
        id:4,
        name:"coupn1",
        code:"35h2",
        product:"Abayas",
        productPrice:250,
        startDate:" 9-may-21",
        endDate:" 25-may-21"
    },
    {
        id:5,
        name:"coupn1",
        code:"87h92",
        product:"Abayas",
        productPrice:250,
        startDate:" 9-may-21",
        endDate:" 25-may-21"
    },
    {
        id:6,
        name:"coupn1",
        code:"0135h2",
        product:"Abayas",
        productPrice:250,
        startDate:" 9-may-21",
        endDate:" 25-may-21"
    }
]
export default Data